import React from 'react';
import { ArrowRight } from 'lucide-react';
import './ctaSection.css';
import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate()
  return (
    <div className="   sm:w-full flex items-center justify-center">
      {/* Mobile View */}
      <div className="flex w-[92vw] justify-center items-center md:hidden py-5 dotted-bg  ">
        <div className=" cta-bg-img rounded-3xl  px-6 py-14 text-white max-w-sm mx-auto shadow-2xl flex flex-col items-center justify-around h-full">
          {/* Heading */}
          <div className="text-center mb-6">
            <h1 className="text-4xl xs:text-3xl font-pp-hatton italic font-bold leading-tight">
              Get the Right <br />
              Business Loan <br />
              Today!
            </h1>
          </div>

          {/* Description */}
          <div className="mb-8  flex justify-center items-center">
            <p className="text-emerald-50 leading-relaxed text-2xl xs:text-xl max-w-[80%] font-atkinson text-center">
              Don't let financial limitations hold your business back. Whether you're planning expansion, managing cash flow, or investing in new opportunities,
              <span className="italic font-medium font-pp-hatton text-white"> Business Loan</span> can be your key to success.
            </p>
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <button
            onClick={()=>{

                                navigate('/business-loan-v1')

                            }}
             className="bg-[#12F280] text-black font-atkinson py-3 xs:py-2 px-6 xs:px-4 rounded-full flex items-center justify-center gap-2 w-full transition-all duration-300 transform hover:scale-105 shadow-lg text-xl xs:text-lg">
              Apply Now
              <img src='/assets/img/Layer_1 (10).png' className='w-[30px] xs:w-[25px]'/>
            </button>

            <p className="text-[#12F280] text-lg mt-3 opacity-80 font-atkinson leading-5">
              & take your business <br/> to the next level!
            </p>
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div className="hidden md:flex dotted-bg w-full min-h-screen justify-center items-center">
        {/* Inner Card */}
        <div className="h-[70vh] cta-bg-img rounded-3xl w-full max-w-6xl mx-auto shadow-2xl flex flex-col justify-around px-8 py-12 text-white">
          {/* Heading */}
          <h1 className="text-4xl lg:text-[2.8rem] font-pp-hatton italic leading-tight text-center lg:text-left">
            Get the Right Business Loan Today!
          </h1>

          {/* Description */}
          <p className="text-emerald-50 text-base lg:text-3xl leading-relaxed max-w-4xl mx-auto text-center lg:text-left font-atkinson">
            Don't let financial limitations hold your business back. Whether you're planning expansion, managing cash flow, or investing in new opportunities,
            <span className="italic font-medium font-pp-hatton text-white"> Business Loan</span> can be your key to success.
          </p>

          {/* CTA Button */}
          <div className="text-center">
            <button 
             onClick={()=>{

                                navigate('/business-loan-v1')

                            }}
            className="bg-[#12F280] text-black font-atkinson py-2.5 px-8 rounded-full inline-flex items-center gap-3 transition-all duration-300 transform hover:scale-105 shadow-lg text-lg">
              Apply Now & take your business to the next level!
               <img src='/assets/img/Layer_1 (10).png' width={27}/>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
